module.exports = __webpack_public_path__ + "static/media/ms.25370d5f.webp";